import {
  DOMAIN_DEV,
  DOMAIN_JELLINEK_ZELFHULP,
  DOMAIN_MENTAAL_BALANS,
  DOMAIN_ZELFHULP_ALCOHOL,
  DOMAIN_ZELFHULP_BEGELEID,
  DOMAIN_ZELFHULP_CANNABIS,
  DOMAIN_ZELFHULP_COCAINE,
  DOMAIN_ZELFHULP_GOKKEN,
  DOMAIN_ZELFHULP_NAASTEN,
  DOMAIN_ZELFHULP_TABAK }
  from '../config/constants';

const possibleDomains = new Set([
  DOMAIN_JELLINEK_ZELFHULP,
  DOMAIN_ZELFHULP_ALCOHOL,
  DOMAIN_ZELFHULP_TABAK,
  DOMAIN_ZELFHULP_GOKKEN,
  DOMAIN_ZELFHULP_CANNABIS,
  DOMAIN_ZELFHULP_COCAINE,
  DOMAIN_ZELFHULP_NAASTEN,
  DOMAIN_ZELFHULP_BEGELEID,
  DOMAIN_MENTAAL_BALANS,
]);

export default function getCurrentDomain() {
  const { hostname } = window.location;
  // For dev, change routing to the one you need for dev, defined in contants or .env file.
  return hostname.split('.').find((part) => possibleDomains.has(part)) || DOMAIN_DEV;
}
